import { insertOrUpdateBlock } from "@blocknote/core";
import type { BnEditor } from "blocks-schema";
import type { PersistedTheme } from "schemas";
import { Icon, iconStyles } from "ui";

export function insertButtonBlockItems(editor: BnEditor, theme: PersistedTheme) {
  const themeProps = {
    buttonBackgroundColor: theme.buttonHexColor || "",
    buttonTextColor: theme.buttonTextColor || "",
    buttonTextAlignment: theme.buttonTextAlignment,
    buttonBorderRadius: theme.buttonBorderRadius,
  };
  return [
    {
      title: "Link Button",
      onItemClick: () =>
        insertOrUpdateBlock(editor, {
          type: "buttonBlock",
          content: [],
          props: {
            ...themeProps,
            buttonType: "Link",
          },
        }),
      aliases: ["button", "link", "url"],
      group: "Content",
      icon: <Icon className={iconStyles.neutral600} iconType="Link" />,
      subtext: "Button that links to a URL",
    },
    {
      title: "Phone Button",
      onItemClick: () =>
        insertOrUpdateBlock(editor, {
          type: "buttonBlock",
          content: [],
          props: {
            ...themeProps,
            buttonType: "Phone",
          },
        }),
      aliases: ["button", "phone", "call"],
      group: "Content",
      icon: <Icon className={iconStyles.neutral600} iconType="PhoneEnabled" />,
      subtext: "Button that initiates a phone call",
    },
    {
      title: "Email Button",
      onItemClick: () =>
        insertOrUpdateBlock(editor, {
          type: "buttonBlock",
          content: [],
          props: {
            ...themeProps,
            buttonType: "Email",
          },
        }),
      aliases: ["button", "email", "mail"],
      group: "Content",
      icon: <Icon className={iconStyles.neutral600} iconType="Mail" />,
      subtext: "Button that opens an email client",
    },
  ];
}
